<template>
  <div class="waitpage-wrapper">
    <header class="waitpage-header">
      <img
        class="header-logo"
        src="@/assets/jiker.com-green-logo.png"
        alt="极客"
      />
    </header>
    <div class="waitpage-body">
      <div class="welcome-section">
        <div class="welcome-content">
          <p>: )</p>
          <p>全新的极客</p>
          <p>伴随清晨的阳光与你见面，欢迎光临！</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {};
</script>

<style type="text/css" lang="less" scoped>
.waitpage-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  // background: #f0f2f5;
  background-image: url("~@/assets/antd-login-bg.svg");
  background-position: 50%;
}

.waitpage-header {
  padding-top: 80px;
  text-align: center;

  .header-logo {
    height: 80px;
  }
}

.waitpage-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.welcome-section {
  .welcome-content {
    font-size: 16px;
    color: #666;

    > p {
      margin: 16px 0;
      letter-spacing: 1px;
    }
  }

  .plus-container {
    margin-top: 32px;
    font-size: 14px;
    color: #999;
    > a {
      text-decoration: none;
      color: #35b558;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.waitpage-footer {
  text-align: center;
  padding: 80px 0;

  .footer-qrcode {
    height: 120px;
    margin-bottom: 16px;
  }

  .footer-qrcode-desc {
    font-size: 12px;
    color: #999;
  }
}
</style>
